import { ENVIRONMENT } from "@evc/platform";
import { baseEnvironment } from "./environment.base";

export const environment = {
  ...baseEnvironment,
  production: false,
  name: ENVIRONMENT.development,
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: 'c19b376e-4f95-49e8-8c9c-44982ae6a79d'
};
